import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { groupsManagement } from "../../../../hooks/api/GroupsManagement";
import { DefaultLayout } from "../../../../layouts/Default";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { Main } from "../../../../themes/Default/components/Main";
import { Title } from "../../../../themes/Default/components/Title";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Formik } from "formik";
import { Form } from "../../../../themes/Default/components/Form";
import { Row } from "../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../themes/Default/components/Form/components/Row/components/Field";
import { Textarea } from "../../../../themes/Default/components/Form/components/Textarea";
import { studentsManagement } from "../../../../hooks/api/StudentsManagement";

const ViewArchiveNote = () => {
    const { t } = useTranslation("common");
    const { selectedGroupId } = useParams();
    const { studentId } = useParams();
    const formRef = useRef(null);
    const navigate = useNavigate();
    const { useViewArchiveNoteParticipantMutation } = groupsManagement;
    const {  useViewStudentsMutation} = studentsManagement;
    const [viewStudents] = useViewStudentsMutation();
    const [student, setStudent] = useState();
    const [viewArchiveGroupParticipant] = useViewArchiveNoteParticipantMutation();
    
    const gotoDetailsTab = (studentId) => {
        navigate("/students/edit/" + studentId);
    };

    const gotoNotesTab = (studentId) => {
        navigate('/students/' + studentId + '/notes');
    }

    const gotoTestsTab = (studentId) => {
        navigate('/students/' + studentId + '/tests');
    }

    const gotoDocumentsTab = (studentId) => {
        navigate('/students/' + studentId + '/documents');
    }

    const gotoCertificatesTab = (studentId) => {
        navigate('/students/' + studentId + '/certificates');
    }

    const gotoContractsTab = (studentId) => {
        navigate("/students/" + studentId + "/contracts");
    };

    const gotoCallsTab = (studentId) => {
        navigate("/students/" + studentId + "/calls");
    };

    const tabs = [
        { title: t('details'), onClick: () => gotoDetailsTab(studentId) },
        // { title: t('students.tests'), onClick: () => gotoTestsTab(studentId)},
        { title: t("students.contract"), onClick: () => gotoContractsTab(studentId) },
        { title: t("calls.title"), onClick: () => gotoCallsTab(studentId) },
        { title: t('groups.title'), isActive: true},
        { title: t('students.certificates'), onClick: () => gotoCertificatesTab(studentId)},
        { title: t('documents'), onClick: () => gotoDocumentsTab(studentId)},
        { title: t('notes'), onClick: () => gotoNotesTab(studentId)},
    ];

    useEffect(() => {
        viewStudents(studentId).then((result) => {
            setStudent(result?.data);
        });

        viewArchiveGroupParticipant({groupId: selectedGroupId, participantId: studentId}).then((result) => {
            formRef.current.setValues(result?.data);
        });
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to={"/students/" + studentId + "/groups"} />
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{student?.firstName} {student?.lastName}</Title>
                <Breadcrumps>
                    <Link title={t('students.title')} icon="fa-user-graduate" />
                    <Link title={t('details')} />
                    <Link title={t('groups.title')} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        note: "",
                    }}
                >
                    {({ values, handleChange, setFieldValue }) => (
                        <Form>
                            <Row>
                                <Field isFullWidth={true}>
                                    <Textarea
                                        rows={6}
                                        name="note"
                                        label={t("groups.reasonForArchiving")}
                                        value={values.note}
                                        disabled={true}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default ViewArchiveNote;